// Windows 8 mobile Responsive utility
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
  var msViewportStyle = document.createElement('style')
  msViewportStyle.appendChild(
    document.createTextNode(
      '@-ms-viewport{width:auto!important}'
    )
  )
  document.querySelector('head').appendChild(msViewportStyle)
}

jQuery(document).ready(function () {
  // LazyLoading
  jQuery("img").unveil(500, function () {
    jQuery(this).on('load', function () {
      jQuery(this).removeAttr("data-src");
    });
  });
  // jQuery('input:text, input, textarea').focus(function(){
	// 	if(this.value === this.defaultValue){
	// 		this.value = '';
	// 	}  
	// });
  jQuery('input:text, input, textarea').blur(function(){
    if (!this.value.length) {
		    this.value = this.defaultValue;
	  }
	});
  jQuery('.modal').on('shown.bs.modal', function () {
    $("img").trigger("unveil");
  });
  jQuery('[data-toggle="tooltip"]').tooltip({
		trigger: "manual"
	})
	.on('mouseenter', function () {
	    var _this = this;
	    $(this).tooltip('show');
	    $('.tooltip').on('mouseleave', function () {
	        $(_this).tooltip('hide');
	    });
	}).on('mouseleave', function () {
	    var _this = this;
	    setTimeout(function () {
	        if (!$('.tooltip:hover').length) {
	            $(_this).tooltip('hide');
	        }
	    }, 300);
	});
  jQuery(".fancybox1").fancybox({
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '768px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  jQuery(".fancybox2").fancybox({ 
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '850px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  jQuery(".fancybox3").fancybox({
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '600px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  jQuery(".fancybox4").fancybox({ 
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '700px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  //$('.selectric').selectric();

  $(".filter-select").selectpicker({
    liveSearch: false,
    noneSelectedText: "Zvolte"
  });

  var maxLength = 600;
  $('textarea#message').keyup(function() {
    var length = $(this).val().length;
    var length = maxLength-length;
    $('#chars').text(length);
  });
  // extra tooltip
  $('.tooltip-extra').click(function(event){
    event.stopPropagation();
  });
  $('.tooltip-extra > span').click(function(event){
    event.stopPropagation();
    if($(this).parent().hasClass('is-active') !== true) {
      $(this).parent().addClass('is-active');
    } else {
      $(this).parent().removeClass('is-active');
    }
  });

    $("#answerSubmitBtn").on('click', function (event) {  
          event.preventDefault();
          var el = $(this);
          el.prop('disabled', true);
          $(this).parents('.answer__button').addClass('disabled');
          // setTimeout(function(){el.prop('disabled', false); }, 3000);
    });
});
/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

'use strict';

;( function ( document, window, index )
{
	var inputs = document.querySelectorAll( '.inputfile' );
	Array.prototype.forEach.call( inputs, function( input )
	{
		var label	 = input.nextElementSibling,
			labelVal = label.innerHTML;

		input.addEventListener( 'change', function( e_inputFile )
		{
			var fileName = '';
			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else
				fileName = e_inputFile.target.value.split( '\\' ).pop();

			if( fileName )
				label.querySelector( 'span' ).innerHTML = fileName;
			else
				label.innerHTML = labelVal;
		});

		// Firefox bug fix
		input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
		input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
	});
}( document, window, 0 ));

function checkOffset() {
    if($('#up').offset().top + $('#up').height() >= $('.footer').offset().top - 10)
      $('#up').css('position', 'absolute');
    if($(document).scrollTop() + window.innerHeight < $('.footer').offset().top)
      $('#up').css('position', 'fixed'); // restore when you scroll up
}
$(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 300) {
    $('#up').fadeIn();
  } else {
    $('#up').fadeOut();
  }
    if(jQuery("#up").length) {
      checkOffset();
    }
});

  hideTooltipExtra = true;
  $('body').on("click", function (d) {
      if (hideTooltipExtra) $('.tooltip-extra').removeClass('is-active');
      hideTooltipExtra = true;
  });

  $('body').on('click', '.question-mark', function (dd) {
    dd.preventDefault();
      var self = $(this).parents('.tooltip-extra');

      if (self.hasClass('is-active')) {
          $('.tooltip-extra').removeClass('is-active');
          return false;
      }

      $('.tooltip-extra').removeClass('is-active');
      

      self.toggleClass('is-active');
      hideTooltipExtra = false;
  });

  $('.tooltip-extra__content--close').click(function(ddd){
    ddd.stopPropagation();
    $(this).parents('.tooltip-extra').removeClass('is-active');
  });


  $('.material-input').on("focus", function() {
    $(this).parent('.material').addClass('focus');
  });

  $('.material-input').focusout(function() {
    $(this).parent('.material').removeClass('focus');
  });

  $(".material-input").blur(function() {
    if(!$(this).val() == ''){
      $(this).parent('.material').addClass('focus');
    }
  });

 
    /* ==========================================================================
    DATEPICKER
  ========================================================================== */

  /* From date
  ========================================================================== */

  $('input.datepicker-input').daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    autoApply: true,
    minDate: "01/01/1900",
    locale: {
      format: "DD.MM.YYYY",
      fromLabel: "Od",
      toLabel: "Do",
      daysOfWeek: [
        "Ne",
        "Po",
        "Út",
        "St",
        "Čt",
        "Pá",
        "So"
      ],
      monthNames: [
        "Leden",
        "Únor",
        "Březen",
        "Duben",
        "Květen",
        "Červen",
        "Červenec",
        "Srpen",
        "Září",
        "Říjen",
        "Listopad",
        "Prosinec"
    ],
      firstDay: 1
    }
  },function (chosen_date) {
      $('input.datepicker-input').val(chosen_date.format('DD.MM.YYYY'));
  }, function(start, end, label) {
    console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
  });
